import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryTabs() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-10 relative z-20">
      <div className="bg-background-50 rounded-2xl p-1 flex flex-wrap gap-1 justify-center border border-background-200/60">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium text-foreground-600 hover:text-primary-500 hover:bg-primary-50/60 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className={`${cat.icon} text-base w-4 h-4 flex items-center justify-center`}></i>
            <span>{cat.name}</span>
            <span className="text-xs text-foreground-400">({cat.count})</span>
          </Link>
        ))}
      </div>
    </section>
  );
}